import { Injectable } from '@angular/core';
import { ResourceService } from './resource.service';
import * as Constants from '../globals/constants';
import { Helper } from '../utilities/helper';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TechnologyService {

  private helper = new Helper();
  public STATE;
  public ASCENSION_STATE;
  public TECHNOLOGY;
  public UI_TECHNOLOGY;
  private resourceService: ResourceService;
  public technologyResearched: Subject<any>;

  constructor(resourceService: ResourceService) {
    this.resourceService = resourceService;
    this.STATE = this.helper.deepCopyObject(Constants.TECH_STATE);
    this.ASCENSION_STATE = this.helper.deepCopyObject(Constants.ASCENSION_STATE);
    this.TECHNOLOGY = Constants.TECHNOLOGY;
    this.UI_TECHNOLOGY = Object.entries(Constants.TECHNOLOGY);
    this.technologyResearched = new Subject();
  }

  public get state() {
    return this.STATE;
  }

  public get ascension_state() {
    return this.ASCENSION_STATE;
  }
  public meetsTechRequirements(technology) {
    if ( this.TECHNOLOGY[technology].tech_requirements.length === 0 ) {
      return true;
    } else {
      let canResearch = true;
      this.TECHNOLOGY[technology].tech_requirements.forEach((requirement) => {
        if (!this.STATE[requirement]) {
          canResearch = false;
        }
      });
      return canResearch;
    }
  }

  public meetsBuildingRequirements(technology) {
    if (
      this.TECHNOLOGY[technology].tech_requirements.length === 0
      && Object.keys(this.TECHNOLOGY[technology].building_requirements).length === 0
    ) {
      return true;
    } else {
      let meetsRequirements = true;
      Object.entries(this.TECHNOLOGY[technology].building_requirements).forEach(building => {
        if (Constants.OWNED_BUILDINGS[building[0]] < building[1] ) {
          meetsRequirements = false;
        }
      });
      return meetsRequirements;
    }
  }

  public research(tech) {
    if (!this.meetsBuildingRequirements(tech)) {
      return false;
    }
    if (this.resourceService.payResource(this.TECHNOLOGY[tech].costs)) {
      this.STATE[tech] = true;
      if (tech === 'colonies') {
        this.resourceService.addFreeAcres(10);
      }
      if (tech === 'automobiles') {
        this.resourceService.addFreeAcres(5);
      }
      if (tech === 'moon_base') {
        this.resourceService.addFreeAcres(20);
      }
      if (tech === 'mars_base') {
        this.resourceService.addFreeAcres(30);
      }
      if (tech === 'space_base') {
        this.resourceService.addFreeAcres(30);
      }
      if (tech === 'terraforming') {
        this.resourceService.addFreeAcres(50);
      }
      Constants.SINGLETON_TECH.STATE = this.STATE;
      this.technologyResearched.next();
    }
  }

  public triggerTechUpdate() {
    this.technologyResearched.next();
  }

  public reset(hardReset = false) {
    if (hardReset) {
      this.ASCENSION_STATE = this.helper.deepCopyObject(Constants.ASCENSION_STATE);
    }
    this.STATE = this.helper.deepCopyObject(Constants.TECH_STATE);
    Constants.SINGLETON_TECH.STATE = this.STATE;
    this.technologyResearched.next();
  }
}
